export const en = {
    add: 'Add'
};
